import type { HelpFile } from '../../types/help'
import { ScriptConfigCardTestIds } from '../../../testids/ScriptConfigCardTestIds'

export const scriptConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/script-connector',
  texts: {
    [ScriptConfigCardTestIds.scriptConfigCard]:
      'Configuration for an outbound script-based connector — defines the operations the script implements and how to invoke them.',
    [ScriptConfigCardTestIds.cardTitleScriptConfig]: null,
    [ScriptConfigCardTestIds.btnCreateScriptConfig]: null,
    [ScriptConfigCardTestIds.btnEditScriptConfig]: null,
    [ScriptConfigCardTestIds.btnValidateScript]:
      'Dry-run call against the script endpoint to validate configuration without making changes.',
  },
}
